"use client";

import { c as _c } from "react/compiler-runtime";
import MaxWidth from "@/app/(main_app)/_components/MaxWidth";
import Skeleton from "../../../_components/global/Skeleton";
import { useGalleryFeed } from "../_hooks/useGalleryFeed";
import CategoryFeedGrid from "./CategoryFeedGrid";
function GridSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ul className="columns-2 gap-3 sm:columns-3 lg:columns-4">{Array.from({
        length: 8
      }).map(_temp)}</ul>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(_, index) {
  return <li key={index} className="mb-3 break-inside-avoid"><Skeleton className="aspect-square w-full" rounded="rounded-[--radius16]" /></li>;
}
function EmptyState(t0) {
  const $ = _c(2);
  const {
    message
  } = t0;
  let t1;
  if ($[0] !== message) {
    t1 = <div className="flex min-h-[240px] flex-col items-center justify-center gap-2 py-8 text-center"><p className="m3-body-medium text-[--textSecondarySecondary]">{message}</p></div>;
    $[0] = message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}

/**
 * Feed grid for a category page. `tagId` is null when the `category` slug
 * isn't in DESIGN_IDEA_TAGS — an empty state shows instead of calling the API.
 */
export default function CategoryGalleryFeedSection(t0) {
  const $ = _c(27);
  const {
    category,
    title,
    tagId,
    initialFeedData
  } = t0;
  const hasMatch = tagId !== null;
  const t1 = hasMatch ? initialFeedData : undefined;
  let t2;
  if ($[0] !== category || $[1] !== t1 || $[2] !== tagId) {
    t2 = {
      category,
      tagId,
      initialData: t1
    };
    $[0] = category;
    $[1] = t1;
    $[2] = tagId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    items,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    loadMoreRef
  } = useGalleryFeed(t2);
  let t3;
  if ($[4] !== hasMatch || $[5] !== title) {
    t3 = !hasMatch && <EmptyState message={`Sorry, there are no images for ${title.toLowerCase()} yet. Try another room above.`} />;
    $[4] = hasMatch;
    $[5] = title;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== hasMatch || $[8] !== isLoading) {
    t4 = hasMatch && isLoading && <GridSkeleton />;
    $[7] = hasMatch;
    $[8] = isLoading;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== hasMatch || $[11] !== isLoading || $[12] !== items) {
    t5 = hasMatch && !isLoading && items.length === 0 && <EmptyState message="No images found for this tag." />;
    $[10] = hasMatch;
    $[11] = isLoading;
    $[12] = items;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== category || $[15] !== hasMatch || $[16] !== hasNextPage || $[17] !== isFetchingNextPage || $[18] !== items || $[19] !== loadMoreRef || $[20] !== title) {
    t6 = hasMatch && items.length > 0 && <><CategoryFeedGrid items={items} title={title} category={category} /><div ref={loadMoreRef} className="h-px w-full" />{isFetchingNextPage && <GridSkeleton />}{!hasNextPage && <p className="py-4 text-center m3-body-medium text-[--textSecondarySecondary]">You've reached the end</p>}</>;
    $[14] = category;
    $[15] = hasMatch;
    $[16] = hasNextPage;
    $[17] = isFetchingNextPage;
    $[18] = items;
    $[19] = loadMoreRef;
    $[20] = title;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== t6) {
    t7 = <section className="w-full bg-[--colorSurfaceSurface]"><MaxWidth padding="px-4" className="pb-8 pt-2 md:pb-12">{t3}{t4}{t5}{t6}</MaxWidth></section>;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
}